import React from 'react'
import { FaEnvelope } from 'react-icons/fa';
import { IoCallOutline } from "react-icons/io5";

function ContactCard({ contact }) {
  const handleCall = () => {
    const rawPhone = contact.mobile || contact.phone || contact.contact_number;
    if (!rawPhone) return;
    window.location.href = `tel:${rawPhone.toString().replace(/\D/g, '')}`;
  };

  const handleEmail = () => {
    if (contact.email) window.location.href = `mailto:${contact.email}`;
  };

  return (
    <div className="activity-item" style={{ padding: '8px 12px', background: '#F9FAFB' }}>
      <div className="activity-avatar" style={{ background: 'rgba(249, 115, 22, 0.1)', color: '#F97316' }}>
        {(contact.name || contact.customer_name || 'C')[0].toUpperCase()}
      </div>
      <div className="activity-content">
        <div className="activity-title" style={{ fontSize: '13px' }}>
          {contact.name || contact.customer_name || 'Unknown'}
        </div>
        <div className="activity-subtitle" style={{ fontSize: '11px' }}>
          {contact.email || 'No email provided'}
        </div>
      </div>
      <div className="d-flex gap-1">
        {(contact.mobile || contact.phone || contact.contact_number) && (
          <button className="btn-secondary" style={{ padding: '6px', minWidth: '32px' }} onClick={handleCall}>
            <IoCallOutline size={14} />
          </button>
        )}
        {contact.email && (
          <button className="btn-secondary" style={{ padding: '6px', minWidth: '32px' }} onClick={handleEmail}>
            <FaEnvelope size={12} />
          </button>
        )}
      </div>
    </div>
  );
}

export default ContactCard
